import useAppState from '../../state/appState';

export const FormValuesDisplay = () => {
    const formValues = useAppState((state) => state.formValues);

    const formValuesMap = [];
    for (const [key, value] of Object.entries(formValues)) {
        formValuesMap.push({ key, value });
    }

    return (
        <div>
            {formValuesMap.map((r) => {
                const { key, value } = r;

                return (
                    <div key={key}>
                        <b>{key}</b>
                        <br />
                        <pre>{JSON.stringify(value, null, 4)}</pre>
                    </div>
                );
            })}
        </div>
    );
};
